import src from "IMAGE";
export default { src, width: 1090, height: 962, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAO0lEQVR42n2P2woAMAhCg/L/f3k4MOZugi92IovMDLqqzMotBHCATXOorRW8Asoa+J2xgnvhWZJ6fUENIEgCZevX/OcAAAAASUVORK5CYII="};
